<template>
  <div id="parentx">
    <vs-sidebar
      default-index="1"
      :parent="parent"
      :hiddenBackground="doNotClose"
      color="primary"
      class="sidebarx"
      spacer
      v-model="isSidebarActive"
      :click-not-close="doNotClose"
    >
      <!-- Header -->
      <div class="header-sidebar text-center" slot="header" v-if="appUser">
        <div v-if="appUser.image" class="avatar-container">
          <img :src="appUser.image" alt="User Avatar" class="avatar-image" />
        </div>
        <div v-else class="avatar-container">
          <img :src="require('@/assets/images/users/3.png')" alt="Default Avatar" class="avatar-image" />
        </div>
        <h4>
          {{ appUser.name }}<br />
          <small>{{ appUser.email }}</small>
        </h4>
        <vs-button v-if="$route.path !== '/edit-profile'" class="edit-profile-button" icon="edit" type="filled" @click="navigateToEditProfile" />
      </div>

      <!-- Sidebar Items -->
      <div v-for="(sidebarLink, index) in sideBars" :key="`sidebarLink-${index}`">
        <!-- Parent Item -->
        <vs-sidebar-item
          :icon="sidebarLink.icon"
          :index="`${index}`"
          :to="!sidebarLink.submenu ? sidebarLink.url : undefined"
          @click="sidebarLink.submenu && toggleSubmenu(index)"
          class="parent-link"
        >
          <span class="hide-in-minisidebar">{{ sidebarLink.name }}</span>
        </vs-sidebar-item>

        <!-- Submenu Items -->
        <div
          v-if="expandedMenu === index && sidebarLink.submenu"
          v-for="(subItem, subIndex) in sidebarLink.submenu"
          :key="`subItem-${index}-${subIndex}`"
        >
          <vs-sidebar-item
            :to="subItem.url"
            :index="`${index}-${subIndex}`"
            :icon="subItem.icon || ''"
            class="submenu-item"
          >
            <span class="hide-in-minisidebar">• {{ subItem.name }}</span>
          </vs-sidebar-item>
        </div>
      </div>

      <!-- Logout -->
      <div @click="logoutPopup = true">
        <vs-sidebar-item icon="exit_to_app">
          <span class="hide-in-minisidebar">Logout</span>
        </vs-sidebar-item>
      </div>

      <!-- Footer -->
      <div class="footer-sidebar" slot="footer">
        <small class="small-text">Powered by Shiv Shakti Softech</small>
      </div>
    </vs-sidebar>

    <!-- Logout Popup -->
    <vs-popup class="holamundo" small title="Logout?" :active.sync="logoutPopup">
      <p>Are you sure you want to Logout?</p>
      <div>
        <vs-button @click="logout">Logout</vs-button>
        <vs-button color="grey" style="margin-left: 15px" @click="logoutPopup = false">Cancel</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import router from "../../../router";

export default {
  name: "SideBar",
  props: {
    parent: String,
    sidebarLinks: {
      type: Array,
      required: true,
    },
    index: {
      default: null,
      type: [String, Number],
    },
  },
  data() {
    return {
      userData: {
        name: "",
        email: "",
        image: "",
      },
      logoutPopup: false,
      doNotClose: false,
      windowWidth: window.innerWidth,
      expandedMenu: null,
    };
  },
  computed: {
    sideBars() {
      return this.sidebarLinks;
    },
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive;
      },
      set(val) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", val);
      },
    },
    appUser() {
      return this.userData;
    },
  },
  methods: {
    toggleSubmenu(index) {
      this.expandedMenu = this.expandedMenu === index ? null : index;
    },
    logout() {
      this.logoutPopup = false;
      router.push("/logout");
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebar();
    },
    setSidebar() {
      if (this.windowWidth < 1170) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", false);
        this.doNotClose = false;
      } else {
        this.$store.commit("IS_SIDEBAR_ACTIVE", true);
        this.doNotClose = true;
      }
    },
    setAppUser() {
      const user = localStorage.getItem("user");
      if (user) {
        this.userData = JSON.parse(user);
      } else {
        this.userData = { name: "", email: "", image: "" };
      }
    },
    updateAppUser() {
      this.setAppUser();
    },
    navigateToEditProfile() {
      this.$router.push("/edit-profile");
    },
  },
  mounted() {
    this.setAppUser();
    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("storage", this.updateAppUser);
    window.addEventListener("user-updated", this.updateAppUser);
    this.setSidebar();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("storage", this.updateAppUser);
    window.removeEventListener("user-updated", this.updateAppUser);
  },
};
</script>

<style scoped>
.footer-sidebar {
  text-align: center;
  height: 40px;
  padding: 10px 0px;
}
.small-text {
  font-size: 12px;
}
.submenu-item {
  padding-left: 25px;
  font-size: 14px;
  color: #666;
}
.header-sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.avatar-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}
.avatar-image {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  object-fit: cover;
}
.edit-profile-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 14px;
  color: white;
  border-radius: 50%;
}
</style>
